<script setup lang="ts">
const { completedSteps, steps } = useOnboarding()
</script>

<template>
  <ProgressIndicator :completed-steps :steps class="px-2" />
</template>
